var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "checklist-box mb-5" }, [
        _c("div", { staticClass: "text-white checklist-title" }, [
          _c(
            "div",
            { staticClass: "h4 mb-0 py-2 text-center font-weight-bold" },
            [
              _c("span", { staticClass: "text-capitalize" }, [
                _vm._v(_vm._s(_vm.firstName))
              ]),
              _vm._v(", Let's Get You Set Up.\n      ")
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "px-3 py-2",
            staticStyle: { "background-color": "#f2fbfe" }
          },
          [
            _vm._l(_vm.courses, function(course, cindex) {
              return _c(
                "div",
                {
                  key: "course_" + cindex,
                  staticClass: "row py-0 mb-2 step-row"
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-10 h6 mb-0 px-0 position-relative" },
                    [
                      _c(
                        "div",
                        { staticClass: "rounded-circle bg-white step-circle" },
                        [_vm._v(_vm._s(cindex + 1))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "step-line" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "step-text" }, [
                        _vm._v(_vm._s(course.title))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-2 h6 mb-0 pl-0 pr-2 mt-2" }, [
                    course.certification_download_link
                      ? _c(
                          "a",
                          {
                            staticClass: "font-weight-bold",
                            staticStyle: { color: "#00ACEE" },
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.viewCourseReport(
                                  course.certification_download_link
                                )
                              }
                            }
                          },
                          [_vm._v("View Certificate")]
                        )
                      : _c(
                          "a",
                          {
                            staticClass: "font-weight-bold",
                            staticStyle: { color: "#00ACEE" },
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.goToCourseLanding(
                                  course.lmsCourseId,
                                  course.lmsUserId
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getCourseBtnName(
                                  course.certification_download_link,
                                  course.courseStatus
                                )
                              )
                            )
                          ]
                        )
                  ])
                ]
              )
            }),
            _vm._v(" "),
            _vm._l(_vm.assessments, function(assessment, aindex) {
              return _c(
                "div",
                {
                  key: "assessment_" + aindex,
                  staticClass: "row py-0 mb-2 step-row"
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-10 h6 mb-0 px-0 position-relative" },
                    [
                      _c(
                        "div",
                        { staticClass: "rounded-circle bg-white step-circle" },
                        [_vm._v(_vm._s(_vm.courses.length + aindex + 1))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "step-line" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "step-text" }, [
                        _vm._v(_vm._s(assessment.title))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-2 h6 mb-0 pl-0 pr-2 mt-2" }, [
                    assessment.complete_attempt_id
                      ? _c(
                          "a",
                          {
                            staticClass: "font-weight-bold",
                            staticStyle: { color: "#00ACEE" },
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.viewReport(
                                  assessment.complete_attempt_id
                                )
                              }
                            }
                          },
                          [_vm._v("View Result")]
                        )
                      : _c(
                          "a",
                          {
                            staticClass: "font-weight-bold",
                            staticStyle: { color: "#00ACEE" },
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.goToAssessmentLanding(
                                  assessment.id,
                                  assessment.inprogress_attempt_id
                                )
                              }
                            }
                          },
                          [_vm._v("Start")]
                        )
                  ])
                ]
              )
            }),
            _vm._v(" "),
            _c("div", { staticClass: "row py-0 mb-2 step-row" }, [
              _c(
                "div",
                { staticClass: "col-10 h6 mb-0 px-0 position-relative" },
                [
                  _c(
                    "div",
                    { staticClass: "rounded-circle bg-white step-circle" },
                    [
                      _vm._v(
                        _vm._s(_vm.courses.length + _vm.assessments.length + 1)
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "step-line" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "step-text" }, [
                    _vm._v("Add Your Mentors")
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-2 h6 mb-0 pl-0 pr-2 mt-2" }, [
                _c(
                  "a",
                  {
                    staticClass: "font-weight-bold",
                    staticStyle: { color: "#00ACEE" },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.openAddMentorModal($event)
                      }
                    }
                  },
                  [_vm._v("Add")]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row py-0 mb-2 step-row" }, [
              _c(
                "div",
                { staticClass: "col-10 h6 mb-0 px-0 position-relative" },
                [
                  _c(
                    "div",
                    { staticClass: "rounded-circle bg-white step-circle" },
                    [
                      _vm._v(
                        _vm._s(_vm.courses.length + _vm.assessments.length + 2)
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "step-text" }, [
                    _vm._v("Pathways Setup by Mentor Mentee")
                  ])
                ]
              ),
              _vm._v(" "),
              _vm._m(0)
            ])
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("MenteeAssessmentLandingPage", {
        ref: "MenteeAssessmentLandingModal",
        attrs: { isModalVisible: _vm.isAssessmentLandingVisible },
        on: {
          closeAssessmentLandingModal: _vm.closeAssessmentLandingModal,
          openAssessmentQuestionModal: _vm.openAssessmentQuestionModal
        }
      }),
      _vm._v(" "),
      _c("MenteeAssessmentQuestionPage", {
        ref: "MenteeAssessmentQuestionModal",
        attrs: { isModalVisible: _vm.isAssessmentQuestionVisible },
        on: { closeAssessmentQuestionModal: _vm.closeAssessmentQuestionModal }
      }),
      _vm._v(" "),
      _c("MenteeFillForm", {
        ref: "MenteeFillFormModal",
        attrs: { isModalVisible: _vm.isMenteeFillFormVisible },
        on: { closeMenteeFillFormModal: _vm.closeMenteeFillFormModal }
      }),
      _vm._v(" "),
      _c("MenteeEditForm", {
        ref: "MenteeEditFormModal",
        attrs: { isModalVisible: _vm.isMenteeEditFormVisible },
        on: { closeMenteeEditFormModal: _vm.closeMenteeEditFormModal }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2 h6 mb-0 pl-0 pr-2 mt-2" }, [
      _c(
        "a",
        {
          staticClass: "font-weight-bold",
          staticStyle: { color: "#00ACEE" },
          attrs: { href: "#" }
        },
        [_vm._v("Contact")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60ca2038", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60ca2038","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manager/checklist.vue
// module id = null
// module chunks = 